<ng-template custom-container-host  [currentComponent]="currentComponent"></ng-template>
